export const it_immobiliare= {

    'bread_title' : 'Immobiliare',
    'label_region': 'Regione',
    'label_city' : 'Città',
};